import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const state = {
    fromCheck: {
        user_name: /^[a-zA-Z0-9\b\u4e00-\u9fa5]{2,20}$/,
        regEn: /[`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/im,
        regCn: /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im,
        password: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/,
        email: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
        code: /^([0-9]){4,4}$/,
    },
    user_info: [],
    // 修改应用详情
    editAppInfo: [],
    addCodeInfo: [],
    // 修改代码位详情
    editCodeInfo: [],
    // 修改屏蔽规则
    editAstrictInfo: [],
    userForm: {
        connect_name: /[a-zA-Z\u4e00-\u9fa5]{2,20}$/,
        connect_mobile: /^1[3456789]\d{9}$/,
        mobile_code: /^[0-9]\d{5}$/,
        company: /[a-zA-Z\d\u4e00-\u9fa5]/,
        account_name: /[a-zA-Z\u4e00-\u9fa5]/,
        account_id_card: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
    },
    userMessage: 0
}

export default new Vuex.Store({
    state
});


// WEBPACK FOOTER //
// ./src/store/store.js